import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { pvqFinancialChildSupportItemValidator } from './validators/item';
import { FinancialChildSupportModel } from './types';

const financialChildSupportValidator: ValidateJSModel<FinancialChildSupportModel> = {
  HasChildSupport: (value, attributes) => {
    if (attributes?.HasChildSupportNotApplicable?.applicable !== false) {
      return {
        presence: true,
        hasValue: { validator: hasYesOrNo },
      };
    }
    return {};
  },

  HasChildSupportNotApplicable: {},

  List: (value, attributes) => {
    if (attributes?.HasChildSupport?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: pvqFinancialChildSupportItemValidator },
      };
    }

    return {};
  },
};

export default financialChildSupportValidator;
